const regYearsArray = (): { year: number; marAug: string; sepFeb: string }[] => {
    let midYearFigure = 50;
    return [...Array(49).keys()].map((year) => {
        const currentYear = year + 2001;
        midYearFigure = midYearFigure + 1;

        const marAug = currentYear.toString().substring(2);
        const sepFeb = midYearFigure;

        return {
            year: year + 2001,
            marAug,
            sepFeb: sepFeb.toString(),
        };
    });
};

const regYearLetter = (registrationDate: Date) => {
    const regYears = regYearsArray();

    const currentMonth = registrationDate.getMonth() + 1;
    const currentYear = registrationDate.getFullYear();
    const regYear = currentMonth < 3 ? currentYear - 1 : currentYear;

    const yearEntry = regYears.find((rY) => rY.year === regYear);
    if (!yearEntry) return;

    if (currentMonth >= 3 && currentMonth <= 8) return yearEntry.marAug;
    return yearEntry.sepFeb;
};
2;
export default regYearLetter;
